import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const BASE = BACKEND_URL; // used to resolve upload URLs

// Public client
export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Admin client — always sends admin password from sessionStorage
export const apiAdmin = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});
apiAdmin.interceptors.request.use((config) => {
  const pw = sessionStorage.getItem("sahder_admin_pw");
  if (pw) config.headers["X-Admin-Password"] = pw;
  return config;
});

// Default categories used only as a fallback while backend loads
export const DEFAULT_CATEGORIES = [
  { value: "dugun", label: "Düğün", accent: "#8A252C", icons: ["fa-solid fa-person-dress", "fa-solid fa-user-tie"], hint: "Nikâh / Düğün töreni" },
  { value: "nisan", label: "Nişan", accent: "#B8860B", icons: ["fa-solid fa-ring"], hint: "Söz / Nişan merasimi" },
  { value: "kina", label: "Kına", accent: "#A44A3F", icons: ["fa-solid fa-person-dress"], hint: "Kına gecesi" },
  { value: "sunnet", label: "Sünnet", accent: "#4A5D23", icons: ["fa-solid fa-child-reaching"], hint: "Sünnet düğünü / merasimi" },
];

export const STATUS_LABEL = {
  pending: "Beklemede",
  approved: "Onaylandı",
  rejected: "Reddedildi",
};

export const TR_MONTHS = [
  "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
  "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık",
];

export const TR_DAYS_SHORT = ["Pzt", "Sal", "Çar", "Per", "Cum", "Cmt", "Paz"];

export const formatTurkishDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  const day = d.getDate().toString().padStart(2, "0");
  const month = TR_MONTHS[d.getMonth()];
  const year = d.getFullYear();
  const hours = d.getHours().toString().padStart(2, "0");
  const minutes = d.getMinutes().toString().padStart(2, "0");
  return `${day} ${month} ${year} · ${hours}:${minutes}`;
};

export const formatDateShort = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  const day = d.getDate().toString().padStart(2, "0");
  const month = TR_MONTHS[d.getMonth()];
  return `${day} ${month}`;
};

export const formatTime = (iso) => {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  const hours = d.getHours().toString().padStart(2, "0");
  const minutes = d.getMinutes().toString().padStart(2, "0");
  return `${hours}:${minutes}`;
};

// Resolve a possibly-relative uploaded file URL to an absolute one
export const resolveUploadUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("http://") || u.startsWith("https://")) return u;
  return `${BACKEND_URL}${u}`;
};
